export default __webpack_public_path__ + "static/media/greenmagic.0042d614.png";